import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

import footerRoutes from "footer_simple.routes";

function Section({ title, children }) {
  return (
    <>
      <MKTypography variant="h5" mt={5} mb={2}>
        {title}
      </MKTypography>
      <MKTypography variant="body2" color="text" component="div">
        {children}
      </MKTypography>
      <Divider sx={{ my: 3 }} />
    </>
  );
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

function Policies() {
  return (
    <>
      <DefaultNavbar routes={[]} sticky />
      <MKBox component="section" pt={14} pb={8}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="dark"
                  borderRadius="lg"
                  coloredShadow="dark"
                  p={3}
                  mt={-3}
                  mx={2}
                >
                  <MKTypography variant="h3" color="white">
                    Policies &amp; Terms
                  </MKTypography>
                  <MKTypography variant="body2" color="white" opacity={0.8}>
                    D Harris Tours, Inc. &mdash; Last updated April 2026
                  </MKTypography>
                </MKBox>

                <MKBox pb={6} px={{ xs: 3, md: 6 }}>

                  <Section title="Cancellation Policy">
                    <p>
                      A cancellation charge of <strong>$650 per bus</strong> applies if your
                      confirmed reservation is not cancelled at least <strong>7 days prior</strong> to
                      the scheduled spot time.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      The <strong>full quoted amount</strong> is charged for cancellations made within
                      72 hours of the scheduled spot time (sports tournament trips are exempt from
                      this provision).
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Weather cancellations:</strong> No cancellation charge is applied when
                      D Harris Tours is notified of a weather-related cancellation by 4:00 PM the day
                      prior to the confirmed trip.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      A confirmed reservation constitutes a guarantee of service. Please contact us
                      as early as possible if your plans change.
                    </p>
                  </Section>

                  <Section title="Payment &amp; Deposit Policy">
                    <p>
                      A <strong>50% deposit</strong> is required to confirm your reservation. The
                      remaining balance is due prior to or on the date of service unless otherwise
                      agreed in writing.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      Accepted payment methods include check (payable to D Harris Tours, Inc.),
                      purchase order, and electronic payment. Please contact us to confirm available
                      options for your booking.
                    </p>
                  </Section>

                  <Section title="Late Payment">
                    A <strong>10% monthly fee</strong> will be added to any invoice that remains
                    unpaid 30 days past the due date.
                  </Section>

                  <Section title="Terms of Service">
                    <p>
                      By booking services with D Harris Tours, Inc. (&ldquo;D Harris Tours,&rdquo;
                      &ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;) or by accessing our
                      website at dharristours.com, you agree to be bound by these terms. If you do
                      not agree, please do not use our services or website.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Use of Website:</strong> The content on this website is provided for
                      general information and booking purposes only. You may not reproduce, duplicate,
                      copy, or redistribute any material from this site without our written consent.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Accuracy:</strong> While we strive to keep information current,
                      availability and pricing are subject to change without notice. Confirmed
                      reservations supersede any pricing displayed on the website.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Limitation of Liability:</strong> D Harris Tours shall not be liable
                      for delays or failure to perform services caused by circumstances beyond our
                      reasonable control, including but not limited to traffic, weather, mechanical
                      failure, or acts of God.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Governing Law:</strong> These terms are governed by and construed in
                      accordance with the laws of the State of California. Any disputes shall be
                      subject to the exclusive jurisdiction of the courts in California.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      We reserve the right to update these terms at any time. Continued use of our
                      services constitutes acceptance of the current terms.
                    </p>
                  </Section>

                  <Section title="SMS Notification Terms">
                    <p>
                      By providing your mobile phone number and opting in to receive SMS messages
                      from D Harris Tours, you agree to our SMS Terms.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Program:</strong> SMS notifications are used for operational
                      communications including trip confirmations, schedule changes, and dispatch
                      alerts.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Frequency:</strong> Message frequency varies based on operational
                      needs. Standard message and data rates may apply based on your carrier plan.
                    </p>
                    <p style={{ marginTop: 8 }}>
                      <strong>Opt-out:</strong> Reply STOP at any time to unsubscribe. Reply HELP
                      for assistance. For full SMS terms visit{" "}
                      <MKTypography
                        variant="body2"
                        color="dark"
                        component="a"
                        href="https://dharristours.simpsf.com/sms-terms-conditions.html"
                        target="_blank"
                        rel="noreferrer"
                      >
                        dharristours.simpsf.com/sms-terms-conditions.html
                      </MKTypography>
                      .
                    </p>
                  </Section>

                  <MKTypography variant="body2" color="text" mt={2}>
                    Questions? Contact us at{" "}
                    <MKTypography variant="body2" color="dark" component="a" href="mailto:juanaharrisdht@att.net">
                      juanaharrisdht@att.net
                    </MKTypography>{" "}
                    or call{" "}
                    <MKTypography variant="body2" color="dark" component="a" href="tel:+14159028542">
                      415.902.8542
                    </MKTypography>
                    .
                  </MKTypography>

                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Policies;
